import styles from "gui/BrowseDashboardsPage/BrowsePage.module.css";
import searchStyles from "gui/browse-shared/search.module.css";

import { ButtonOld } from "components/ButtonOld/ButtonOld";
import { FieldLabel } from "gui/input/fields";
import { InputText } from "gui/input/input";

import { useSession } from "gui/session/session";
import useFreetextFilterState from "gui/browse-shared/useFreetextFilterState";

/*
 * This sidebar uses state from the exported hooks here. The page that
 * renders this sidebar should use the same state in the apiParams.
 */
export { useFreetextFilterState };

export default function DiscoverTeamsSidebar() {
  const { freetextFilter, setFreetextFilter } = useFreetextFilterState();

  const isLoggedIn = Boolean(useSession());

  return (
    <>
      <aside className={styles.searchOptions}>
        <FieldLabel label="Search for teams">
          <InputText
            placeholder="Dune..."
            autoComplete="off"
            type="search"
            value={freetextFilter}
            onChange={(event) => {
              setFreetextFilter(event.target.value);
            }}
          />
        </FieldLabel>

        {isLoggedIn && (
          <div className={searchStyles.create}>
            <ButtonOld href="/settings/teams" size="sm" color2 light>
              New team
            </ButtonOld>
          </div>
        )}
      </aside>
    </>
  );
}
